export const ADD_CAT_DETAILS = "ADD_CAT_DETAILS";
export const FETCH_ALL_CATEGORY_DETAILS_LIST =
  "FETCH_ALL_CATEGORY_DETAILS_LIST";
export const EDIT_CATEGORY_DETAILS = "EDIT_CATEGORY_DETAILS";
export const UPDATE_CATEGORY_DETAILS = "UPDATE_CATEGORY_DETAILS";
export const DELETE_CATEGORY_DETAILS = "DELETE_CATEGORY_DETAILS";
export const CLEAR_CATEGORY_EDIT = "CLEAR_CATEGORY_EDIT";
export const FETCH_ONLY_PRODUCT_CATEGORY_LIST =
  "FETCH_ONLY_PRODUCT_CATEGORY_LIST";
